import React, { useEffect } from "react";
import { requestForToken } from "./firebase";
import { BrowserRouter as Router, Switch, Route, useHistory, useLocation } from "react-router-dom";
import logger from "./services/logger";
import { initializeEventTracking } from "./services/eventTracking";

import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
//import Commonheader from "./components/Commonheader";
import Create_view from "./components/Create_view";
import View_list from "./components/View_list";

import { FilterContextProvider } from "./context/FilterToDepositSlip";
// AT-2018 | AT-2260 | Ankur Makavana | 03/08/2023 | create new screen for transformation
import Transformation from "./components/Transformation";
import Transformation_mapping from "./components/Transformation_mapping";
import Transformation_mapping_list from "./components/Transformation_mapping_list";
import ND_values from "./components/ND_values";
import "./assets/css/main.css";
import Vendor_specific_fields from "./components/Vendor_specific_fields";
import Nd_Fields from "./components/Nd_fields";
import Update from "./components/Update";

import Update_nd_values from "./components/Update_nd_values";
import Test from "./components/Test";
//import e from "./components/e";
import Element_permissions from "./components/Element_permissions";
import Cache_view_delete from "./components/Cache_view_delete";
import SwitchProdPilot from "./components/Switch";
import Performance_view from "./components/Performance_view";
import Permission from "./components/Permission";
import Service_configuration from "./components/Service_configuration";
import Service from "./components/Service";
import User_permission from "./components/User_permission";
import Dropdown_master from "./components/Dropdown_master";
import ExecuteServiceConfig from "./components/ExecuteServiceConfig.jsx";
import UpdateExecuteServiceConfig from "./components/updateExecuteServiceConfig.jsx";


import User_functionality from "./components/User_functionality";
import Decrypt_payload from "./components/Decrypt_payload";
import Field_mapping from "./components/Field_mapping";
import Unblock_user from "./components/Unblock_user";import { PermissionsProvider } from "./components/permissionComponents/PermissionContext";
import ServiceClone from "./components/ServiceClone.js";
import RouteTracker from "./components/RouteTracker";

require("dotenv").config();
//import Notification from './Notification';
function App() {
  requestForToken();

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "SESSION_LOGOUT_BROADCAST" && e.newValue) {
        console.log("Logout broadcast detected from another tab. Clearing session and redirecting to login...");
        localStorage.clear();
        window.location.href = "/";
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <>
      <Router basename="/">
        <RouteTracker />
        <React.StrictMode>
          <PermissionsProvider>
            <FilterContextProvider>
              <Switch>
                <Route
                  exact={true}
                  path="/update_nd_value"
                  component={Update_nd_values}
                />
                <Route exact={true} path="/dashboard" component={Dashboard} />
                <Route exact={true} path="/View" component={Create_view} />
                <Route exact={true} path="/ViewList" component={View_list} />
              <Route exact={true} path="/ViewList" component={View_list} />
              <Route exact={true} path="/Service-clone" component={ServiceClone} />
              <Route
                exact={true}
                path="/Service_configuration"
                component={Service_configuration}
              />
                <Route
                  exact={true}
                  path="/Vendor_specific_fields"
                  component={Vendor_specific_fields}
                />
                <Route
                  exact={true}
                  path="/Vendor_specific_fields_update"
                  component={Update}
                />
                {/* <Route exact={true} path="/Nd_Fields" component={Nd_Fields} /> */}
                {/* AT-2018 | AT-2260 | Ankur Makavana | 03/08/2023 | create new screen for transformation */}
                <Route
                  exact={true}
                  path="/Transformation_mapping_list"
                  component={Transformation_mapping_list}
                />
                <Route
                  exact={true}
                  path="/Transformation"
                  component={Transformation}
                />
                <Route
                  exact={true}
                  path="/Transformation_mapping"
                  component={Transformation_mapping}
                />
              <Route exact={true} path="/Permission" component={Permission} />

                <Route exact={true} path="/ND_values" component={ND_values} />
                <Route exact={true} path="/Test" component={Test} />
                <Route
                  exact={true}
                  path="/Cache"
                  component={Cache_view_delete}
                />
                <Route
                  exact={true}
                  path="/Switch"
                  component={SwitchProdPilot}
                />
              <Route exact={true} path="/Permission" component={Permission} />
              <Route exact={true} path="/User_permission" component={User_permission} />
              <Route exact={true} path="/executeservice" component={ExecuteServiceConfig} />
              <Route exact={true} path="/executeservice/edit" component={UpdateExecuteServiceConfig} />
              <Route
                exact={true}
                path="/Dropdown_master"
                component={Dropdown_master}
              />
              <Route
                exact={true}
                path="/User_functionality"
                component={User_functionality}
              />
              <Route
                exact={true}
                path="/Dropdown_master"
                component={Dropdown_master}
              />
              <Route
                exact={true}
                path="/Unblock_user"
                component={Unblock_user}
              />
                <Route
                  exact={true}
                  path="/Performance_view"
                  component={Performance_view}
                />

<Route
                exact={true}
                path="/Element_permission"
                component={Element_permissions}
              />
              <Route
                exact={true}
                path="/Decrypt_payload"
                component={Decrypt_payload}
              />
              <Route
                exact={true}
                path="/field_mapping"
                component={Field_mapping}
              />
                <Route exact={true} path="/" component={Login} />
              </Switch>
            </FilterContextProvider>
          </PermissionsProvider>
        </React.StrictMode>
      </Router>
    </>
  );
}

export default App;
